import Slider from 'rc-slider'
import React, { useState } from 'react'

const FormSlider = ({
  type = 'Slider',
  defaultValue = 0,
  value = null,
  sliderMin = 0,
  sliderMax = 0,
  sliderStep = 0,
  sliderMarks = {},
  className = null,
  onChange = null,
  onAfterChange = null
}) => {
  const [sliderValue, setSliderValue] = useState(
    value !== null ? value : defaultValue
  )

  const updateSliderValue = newSliderValue => {
    if (sliderValue !== newSliderValue) {
      setSliderValue(newSliderValue)

      /* Broadcast value change, in case we pass an onChange listener function via props */
      onChange(newSliderValue)
    }
  }
  return (
    <Slider
      range={type === 'Range'}
      value={value !== null ? value : defaultValue}
      min={sliderMin}
      max={sliderMax}
      step={sliderStep}
      onChange={updateSliderValue}
      onAfterChange={onAfterChange}
      marks={sliderMarks}
      className={`FormSlider ${className ? className : ''}`}
    />
  )
}

export default FormSlider
